import { ChakraBox, Text } from '@equip.health/ui';

import Header from '~/components/common/Header';
import { PAGE_LAYOUT, PAGE_TOP_PADDING } from '~/lib/constants';

import BulkJobSubmit from './provider-assignment/BulkJobSubmitPanel';
import PollJobStatus from './provider-assignment/PollJobPanel';

const TOP_LEVEL_ID = 'tech-ops';

const TechOps = () => {
  return (
    <ChakraBox
      id={TOP_LEVEL_ID}
      paddingRight={PAGE_LAYOUT.rightSpacing}
      paddingTop={PAGE_LAYOUT.topSpacing}
    >
      <Header title="Tech Ops" />
      <ChakraBox marginTop={PAGE_TOP_PADDING}>
        <ChakraBox
          background="neutral.background.primary"
          borderRadius="8px"
          padding="24px"
        >
          <Text marginBottom="24px" variant="h4">
            Provider Assignments bulk job
          </Text>

          <BulkJobSubmit topLevelId={TOP_LEVEL_ID} />

          <PollJobStatus topLevelId={TOP_LEVEL_ID} />
        </ChakraBox>
      </ChakraBox>
    </ChakraBox>
  );
};

export default TechOps;
